/**
 * Парсит код маркировки и извлекает штрихкод (GTIN)
 * @param {string} code - Код маркировки
 * @returns {Object} { gtin: string, markCode: string } или null
 */
export const parseMarkingCode = (code) => {
    if (!code) return null;

    // Потребительская упаковка: 14 цифр + криптохвост
    // Формат: GGGGGGGGGGGGGG + криптохвост (любые символы)
    // Минимальная длина: 14 (GTIN) + минимум 6 символов криптохвоста = 20
    if (code.length >= 20 && /^\d{14}/.test(code)) {
        const gtin = code.substring(0, 14).replace(/^0+/, ''); // Убираем ведущие нули
        return { gtin, markCode: code };
    }

    // Групповая упаковка: ищем паттерн с кодами применения
    const gtinMatch = code.match(/01(\d{14})/);
    if (gtinMatch) {
        const gtin = gtinMatch[1].replace(/^0+/, '');
        return { gtin, markCode: code };
    }

    return null;
};

/**
 * Проверяет, является ли код маркировкой
 */
export const isMarkingCode = (code) => {
    return parseMarkingCode(code) !== null;
};

/**
 * Проверяет соответствие маркировки штрихкоду товара
 */
export const validateMarkingForProduct = (markingCode, productBarcode) => {
    const parsed = parseMarkingCode(markingCode);
    if (!parsed) return false;

    // Сравниваем GTIN из маркировки с штрихкодом товара (оба без ведущих нулей)
    const normalizedProductBarcode = productBarcode.replace(/^0+/, '');
    return parsed.gtin === normalizedProductBarcode;
};